import React, { FC } from 'react'
import Layout from '@components/common/Layout'

interface Props {
    authRequired: boolean
    pageProps: any
}

const PdpLayout: FC<Props> = ({ children, pageProps, authRequired }) => {
    return (
        <div className="pdp-page">
            <Layout pageProps={pageProps} authRequired={authRequired}>
                {children}
            </Layout>
        </div>
    )
}

export default PdpLayout
